import React from 'react';
import CircularProgressbar from 'react-circular-progressbar';
const AdditionalSkill = (props) => (
    <div className="additional-skill">
        <CircularProgressbar initialAnimation={true} percentage={props.value} />
        <div className="skill-title">
            {props.title}
        </div>
    </div>
);

export default AdditionalSkill;


// WEBPACK FOOTER //
// ./src/components/skills/Charts/aditionalSkill.js